import {APARTADOS} from "../Constantes";
import {scrolearAComponente} from "./scrolearAComponente";
import {useNavigate} from "react-router-dom";

export const useIrRuta = () => {
    const navigate = useNavigate()

    const ir = (secc) => {

        switch (secc) {
            case 'Inicio':
                navigate('/Home');
                break
            case APARTADOS[0]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente(APARTADOS[0])
                }, 500)
                break
            case APARTADOS[1]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente(APARTADOS[1])
                }, 500)
                break
            case APARTADOS[2]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente(APARTADOS[2])
                }, 500)
                break
            case APARTADOS[3]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente(APARTADOS[3])
                }, 500)
                break

        }
    }

    return {
        ir
    }


}